import '@/assets/js/jQuery.md5'
import store from '@/store'
import axios from '@/http'
export default {
  cur_query: {},
  name: process.env.VUE_APP_LOGIN_NAME,
  passw: process.env.VUE_APP_LOGIN_PASSWORD,
  $store: store,
  $http: axios,
  async autoLogin () {
    return new Promise((resolve, reject) => {
      console.log(11111)
      const root = this.$store.state.IPPORT
      const url =
        root +
        '/api/v1/Login?user=' +
        encodeURIComponent(this.name) +
        '&password=' +
        encodeURIComponent($.md5(this.passw)) +
        ''
      if (!this.name || !this.passw) {
        console.log('您未配置自动登陆用户名或密码')
        reject()
      }
      this.$http.get(url).then(result => {
        if (result.status == 200) {
          if (result.data.bStatus) {
            const data = result.data
            if (data.bWeakPassword == true) {
              this.$store.state.oldstrPasswd = encodeURIComponent($.md5(this.passw))
              this.$store.state.token = data.strSession
              sessionStorage.mcutoken = this.$store.state.token
            } else {
              this.$store.state.oldstrPasswd = encodeURIComponent($.md5(this.passw))
              this.$store.state.token = data.strSession
              sessionStorage.mcutoken = this.$store.state.token
              this.loginroot(data.strSession, root)
              this.KeepSession(data.strSession)
            }
            resolve()
          } else {
            reject()
          }
        } else {
          reject()
        }
      }).catch(e => {
        reject()
      })
    })
  },
  async login (to, from, next) {
    console.log(22222)
    let root = this.$store.state.IPPORT
    var url =
      root +
      '/api/v1/Login?user=' +
      encodeURIComponent(this.name) +
      '&password=' +
      encodeURIComponent($.md5(this.passw)) +
      ''
    if (!this.name || !this.passw) {
      console.log('您未配置自动登陆用户名或密码')
      next('/login')
    }
    const result = await this.$http.get(url)
    if (result.status == 200) {
      if (result.data.bStatus) {
        const data = result.data
        if (data.bWeakPassword == true) {
          this.$store.state.oldstrPasswd = encodeURIComponent($.md5(this.passw))
          this.$store.state.token = data.strSession
          sessionStorage.mcutoken = this.$store.state.token
        } else {
          this.$store.state.oldstrPasswd = encodeURIComponent($.md5(this.passw))
          this.$store.state.token = data.strSession
          sessionStorage.mcutoken = this.$store.state.token
          this.loginroot(data.strSession, root)
          this.KeepSession(data.strSession)
        }
        next()
      } else {
        next('/login')
      }
    } else {
      next('/login')
    }
  },
  loginroot (strSession, root) {
    var url =
      root +
      '/api/v1/GetUserInfo?user=' +
      encodeURIComponent(this.name) +
      '&session=' +
      strSession
    this.$http.get(url).then((result) => {
      if (result.status == 200) {
        var data = result.data
        this.$store.state.user = data.strUser
        this.$store.state.root = data.strUserType
        sessionStorage.mcuuser = this.$store.state.user
        sessionStorage.mcuroot = this.$store.state.root
      }
    })
  },
  KeepSession (session) {
    let root = this.$store.state.IPPORT
    var url = root + '/api/v1/Keepalive?session=' + session
    this.$http.get(url).then((res) => {
      if (res.status == 200) {
      }
    })
  },
}
